import { useT } from '../i18n';
import { Button } from './Button';

/**
 * Главная нового пользователя: ни связей, ни отправленных ссылок. Один вопрос, одна кнопка.
 * Без слайдов и приветствий — действие вместо пустого списка.
 */
export function FirstStep({
  pending,
  onCreate,
  onSkip,
}: {
  pending: boolean;
  onCreate: () => void;
  onSkip: () => void;
}) {
  const t = useT();
  return (
    <section
      data-testid="first-step"
      className="flex flex-1 flex-col items-center justify-center gap-4 px-2 text-center"
    >
      <h2 className="text-2xl font-semibold">{t.onboarding.title}</h2>
      <p className="text-hint">{t.onboarding.body}</p>
      <Button data-testid="first-step-create" disabled={pending} onClick={onCreate}>
        {t.onboarding.cta}
      </Button>
      <button
        type="button"
        data-testid="first-step-skip"
        className="py-2 text-link"
        onClick={onSkip}
      >
        {t.onboarding.skip}
      </button>
    </section>
  );
}
